import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ isAuthenticated, component: Component , ...rest}) => {
    // console.log(isAuthenticated)
    return isAuthenticated ? <Component {...rest} /> : <Navigate to="/SignIn" />;
};

export default PrivateRoute;


